import React from 'react';
import {Link} from "react-router-dom";

function Rules() {
    return (
        <div className="rules">
            <div className="rulesContent">
                <b>О конкурсе</b>
                <ol>
                    <li>Все пользователи, загрузившие фото и получившие результат, становятся участниками конкурса.</li>
                    <li>Конкурс продлится с 18 марта по 6 апреля.</li>
                    <li>11 апреля мы случайным образом определим 3-х победителей, которые получат призовые наборы от телеканала Ю.</li>
                </ol>
            </div>
            <div className="rulesLinks">
                <Link to="https://flami-dev.ru/rules.pdf" target={'_blank'}>Правила конкурса</Link>
                <Link to="https://flami-dev.ru/agreement.pdf" target={'_blank'}>Пользовательское соглашение</Link>
            </div>
        </div>
    );
}

export default Rules;
